var FormatFactory = require('../../../../factory/formats');

module.exports = {
  eventCategory: 'Editor UI | Tool Menu | templates',

  thumbnailClickEvent: function (event) {
    var $button = $(event.currentTarget);

    FormatFactory.getFormat($button.data('key')).then(_.bind(function (format) {
      this.trackEvent({
        eventAction: 'show_format',
        eventLabel: format['string_id'] + ' ' + format['id']
      });
    }, this));
  }
};
